import { Button } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';
import { useGetCompanyQuery } from '@blockpulse3/graphql/hooks';

import { StepFormContextProvider } from '../../provider';
import { OnboardingStep } from '../OnboardingStep';
import { CompanyOwners } from '../forms';

type Props = unknown;

export function OnboardingExistingCompanyOwners(): JSX.Element {
  const i18nOwners = useTranslations('OwnersForm');
  const i18nGeneral = useTranslations('General');

  const navigate = useNavigate();

  const { companyId = '' } = useParams();
  const { data } = useGetCompanyQuery({
    variables: { companyId },
    skip: !companyId,
  });

  const handleStepSubmit = (): void => {
    navigate(routes.onboardings.company.access.fmt(companyId));
  };

  const handleStepCancel = (): void => {
    navigate(routes.onboardings.company.representatives.fmt(companyId));
  };

  return (
    <StepFormContextProvider>
      <OnboardingStep
        title={i18nOwners('Title')}
        subTitle={i18nOwners('Subtitle', {
          companyName: data?.company.name || '',
        })}
      >
        <CompanyOwners onCancel={handleStepCancel} onSubmit={handleStepSubmit} />
        <Button key="cancel" variant="secondary" w="full">
          {i18nGeneral('Back')}
        </Button>
        <Button key="submit" data-cy="next" w="full">
          {i18nGeneral('Next')}
        </Button>
      </OnboardingStep>
    </StepFormContextProvider>
  );
}

export type OnboardingExistingCompanyOwnersProps = Props;
